if (!customElements.get('notify-me')) {
  customElements.define(
    'notify-me',
    class NotifyMe extends HTMLElement {
      constructor() {
        super();
        this.variantChangeUnsubscriber = undefined;
      }

      connectedCallback() {
        // Toggle the panel and keep the captured product/variant context in sync
        // whenever the selected variant changes, without re-rendering the form.
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (event.data.sectionId !== this.dataset.sectionId) return;

          const variant = event.data.variant;
          const unavailable = !variant || variant.available === false;
          this.classList.toggle('hidden', !unavailable);

          if (!variant) return;

          const titleField = this.querySelector('.notify-me__variant-title');
          if (titleField) titleField.value = variant.title ?? '';

          const urlField = this.querySelector('.notify-me__variant-url');
          if (urlField && variant.id) {
            const url = new URL(urlField.value, window.location.origin);
            url.searchParams.set('variant', variant.id);
            urlField.value = url.toString();
          }
        });
      }

      disconnectedCallback() {
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }
    }
  );
}
